import * as cidade from '@/api/cidades'
import { convertSelectCidade } from '../../service/collection'
const state = {
  lista: {}
}

const mutations = { }

const actions = {
  async getCidades ({ commit }) {
    let data = await cidade.getCidadesSelect()
    data = convertSelectCidade(data.list)
    return data
  },
  async getCidadesFiltro ({ commit }, payload) {
    let data = await cidade.getCidadesFiltro(payload)
    data = convertSelectCidade(data.list)
    return data
  }
}

export default { namespaced: true, state, mutations, actions }



// WEBPACK FOOTER //
// ./src/store/modules/cidades.js